/**
 * Selectors
 *
 * It's like "views" in relational databases.
 * Store the most efficient format in the reducer state.
 * But to retrieve into easy to consume form, use selector.
 */
import { RootState } from "src/ipm-shared/store/model/reducers";
import ReducerFactory from "src/ipm-shared/Utils/ReduxReducer";
import account_users from "./reducers";
ReducerFactory.registerReducer({ account_users });

export const shouldDisplayLoadingUsers = (state: RootState) =>
  state.account_users.isFetching;

export const getListAccountUser = (state: RootState) =>
  state.account_users.listAccountUser;
